import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../services/authentication.service';
import { inject } from '@angular/core';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
    const authenticationService = inject(AuthenticationService);
    const currentUser = authenticationService.currentUserValue;

    const addAuthHeader = (request: any) => {
        if (currentUser && currentUser.jwtToken) {
            const headers: any = {
                Authorization: `Bearer ${currentUser.jwtToken}`
            };
            
            const userPermissions = authenticationService.currentUserPermissions;
            if (userPermissions && userPermissions.length > 0) {
                headers['X-User-Role'] = userPermissions[0].toString();
                headers['X-User-Permissions'] = userPermissions.join(',');
            }
            
            if (currentUser.roles && currentUser.roles.length > 0) {
                headers['X-User-Role-Id'] = currentUser.roles[0].id.toString();
                headers['X-User-Role-Name'] = currentUser.roles[0].name;
            }
            
            return request.clone({
                setHeaders: headers
            });
        }
        return request;
    };

    const authReq = addAuthHeader(req);

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && currentUser && currentUser.refreshToken) {
                return authenticationService.refreshToken().pipe(
                    switchMap(() => {
                        const newAuthReq = addAuthHeader(req);
                        return next(newAuthReq);
                    }),
                    catchError((refreshError) => {
                        authenticationService.logout();
                        return throwError(() => refreshError);
                    })
                );
            }
            return throwError(() => error);
        })
    );
};